var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseBottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 94,
    viewBox: "0 0 109 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38_1488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 120C4.44771 120 4 119.552 4 119L4 1C4 0.447716 4.44772 5.33895e-09 5 1.19249e-08L65.5 7.3338e-07C87.3152 9.93524e-07 105 17.6848 105 39.5L105 119C105 119.552 104.552 120 104 120L5 120Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 119L4.5 1C4.5 0.723858 4.72386 0.5 5 0.5L65.5 0.500001C87.0391 0.500001 104.5 17.9609 104.5 39.5L104.5 119C104.5 119.276 104.276 119.5 104 119.5L5 119.5L4.89941 119.49C4.67145 119.444 4.5 119.242 4.5 119Z",
    stroke: "#D5D5D5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_38_1488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7334 77.5093C54.1369 78.3702 52.8631 78.3702 52.2666 77.5093L37.6826 56.4585C36.9934 55.4637 37.7058 54.104 38.916 54.104L68.084 54.104C69.2942 54.104 70.0066 55.4637 69.3174 56.4585L54.7334 77.5093Z",
    fill: "#91E2CA",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3662 62.4998C53.9813 63.1664 53.0187 63.1664 52.6338 62.4998L34.0146 30.2498C33.6297 29.5831 34.1111 28.7498 34.8809 28.7498L72.1191 28.7498C72.8889 28.7498 73.3702 29.5831 72.9854 30.2498L54.3662 62.4998Z",
    fill: "#5DAF97",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38_1488",
    x: 0,
    y: 0,
    width: 109,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_1488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_1488",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_38_1488",
    x: 28.8774,
    y: 27.7498,
    width: 49.2451,
    height: 58.9048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_1488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_1488",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBottom);
export default __webpack_public_path__ + "static/media/close_bottom.cfdbb231a3bc24d3164423c247e2c164.svg";
export { ForwardRef as ReactComponent };